import { useState } from "react";
import Radio from "./base/Radio.jsx";
import ToggleSlider from "./base/ToggleSlider.jsx";
import { theme } from "../theme.js";

export default function RegistrationOption({ option, isEditMode, formData, setFormData, acceptedOptions, onToggle }) {
  const [hoveredOption, setHoveredOption] = useState(null);

  const optionId = option.id_bdd || option.id || option.name;
  const isExisting = isEditMode && formData?.existingOptions && formData.existingOptions[optionId];
  const radioChoice = { ...option, name: optionId, label: option.name };

  return (
    <div style={{ ...styles.optionContainer, ...(isExisting ? styles.existingOptionContainer : {}) }}>
      <div style={styles.optionLabelContainer}>
        <div style={styles.optionLabel}>
          <span style={styles.optionLabelLeft}>
            {option.name}
            {option.description && (
              <div
                style={styles.infoIcon}
                onMouseEnter={() => setHoveredOption(optionId)}
                onMouseLeave={() => setHoveredOption(null)}
              >
                i
                {hoveredOption === optionId && (
                  <div style={styles.tooltip}>
                    {option.description}
                  </div>
                )}
              </div>
            )}
            {option.required && <span style={styles.mandatoryStar}>*</span>}
          </span>
          <span style={styles.optionPrice}>
            {option.price === 0 && "Gratuit"}
            {option.price !== 0 && !isExisting && <span style={{ whiteSpace: "nowrap" }}>{option.price} €</span>}
            {option.price !== 0 && isExisting && "Déjà acheté"}
          </span>
        </div>
      </div>

      {option.required ? (
        <Radio
          choice={radioChoice}
          formData={formData}
          setFormData={setFormData}
          trackInExtraOptions={true}
        />
      ) : (
        <>
          <ToggleSlider
            checked={acceptedOptions[optionId] || false}
            onChange={() => !isExisting && onToggle(option)}
            label={isExisting ? "Option déjà achetée" : "Ajouter cette option"}
            size="medium"
            disabled={isExisting}
          />
          {acceptedOptions[optionId] && option.type === "enum" && (
            <div style={styles.optionChoices}>
              <Radio
                choice={radioChoice}
                formData={formData}
                setFormData={setFormData}
                trackInExtraOptions={true}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
}

const styles = {
  optionContainer: {
    padding: theme.spacing.lg,
    marginBottom: theme.spacing.lg,
    backgroundColor: theme.colors.white,
    border: `1px solid ${theme.colors.border}`,
    borderRadius: theme.radius.lg,
    boxShadow: theme.shadows.sm,
    transition: theme.transitions.base,
    alignSelf: "start",
  },
  existingOptionContainer: {
    backgroundColor: theme.colors.bgLight,
    border: `2px solid ${theme.colors.info || theme.colors.primary}`,
    opacity: 0.8,
  },
  optionLabelContainer: {
    marginBottom: theme.spacing.md,
    borderBottom: `2px solid ${theme.colors.bgLight}`,
    paddingBottom: theme.spacing.md,
  },
  optionLabel: {
    fontSize: theme.fonts.size.md,
    fontWeight: theme.fonts.weight.semibold,
    color: theme.colors.textInverted,
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: theme.spacing.xs,
    flexWrap: "nowrap",
  },
  optionLabelLeft: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.xs,
    flexWrap: "wrap",
    width: "80%",
  },
  optionPrice: {
    fontWeight: theme.fonts.weight.semibold,
    color: theme.colors.primary,
    whiteSpace: "nowrap",
    marginLeft: "auto",
    paddingLeft: theme.spacing.sm,
  },
  mandatoryStar: {
    color: theme.colors.error,
    fontSize: theme.fonts.size.lg,
    fontWeight: theme.fonts.weight.bold,
    marginLeft: theme.spacing.xs,
  },
  infoIcon: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    backgroundColor: theme.colors.info || theme.colors.primary,
    color: theme.colors.textInverted,
    fontSize: theme.fonts.size.sm,
    fontWeight: theme.fonts.weight.bold,
    cursor: "help",
    position: "relative",
    marginLeft: theme.spacing.sm,
  },
  tooltip: {
    position: "absolute",
    bottom: "125%",
    left:"0%",
    backgroundColor: theme.colors.gray800,
    color: theme.colors.white,
    padding: `${theme.spacing.sm} ${theme.spacing.md}`,
    borderRadius: theme.radius.md,
    fontSize: theme.fonts.size.sm,
    whiteSpace: "wrap",
    zIndex: theme.zIndex.tooltip,
    boxShadow: theme.shadows.lg,
    pointerEvents: "none",
    minWidth: "200px",
  },
  optionChoices: {
    marginTop: theme.spacing.md,
    paddingTop: theme.spacing.md,
    borderTop: `1px solid ${theme.colors.bgLight}`,
  },
};
